import { hasClass, removeClass, addClass } from '@utils/domUtils';

export default class PublishChannelSelector {
  static selectorString() {
    return '.PublishChannelSelector';
  }

  getSelectedChannels() {
    return this.channels
      .filter(channel => channel.checkbox.checked)
      .map(channel => ({
        label: channel.label,
        runtime: channel.runtime,
        price: channel.price,
      }));
  }

  render(node, props) {
    this.channels = [...node.querySelectorAll('.select-channel')].map(element => {
      element.checkbox = element.querySelector('input[type="checkbox"]');
      element.label = element.getAttribute('data-label');
      element.runtime = element.getAttribute('data-runtime');
      element.price = element.getAttribute('data-price');
      element.addEventListener('click', this.togglePublishChannel.bind(this));
      return element;
    });
  }

  togglePublishChannel(event) {
    event.preventDefault();
    const checkbox = event.currentTarget.checkbox;

    if (hasClass(event.currentTarget, 'channel-selected')) {
      removeClass(event.currentTarget, 'channel-selected');
      checkbox.checked = false;
    } else {
      addClass(event.currentTarget, 'channel-selected');
      checkbox.checked = true;
    }
  }
}
